// DO NOT EDIT -- generated from fs/services/search-settings/elementpropertyrules.proto

import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';
import * as vars from '../../api/vars';

export namespace ElementPropertyRules {

  export const ArchiveElementPropertyRuleEndpoint = "/grpc/search_settings.ElementPropertyRules/ArchiveElementPropertyRule";
  /**
   * Archive an existing element property rule for an org.
   * Once archived, the element property rule cannot be modified and will not show up in GetAllElementPropertyRules unless explicitly requested.
   */
  export function ArchiveElementPropertyRule(sender: (req: ArchiveElementPropertyRuleRequest, endpoint: string) => Promise<ArchiveElementPropertyRuleResponse>, req: ArchiveElementPropertyRuleRequest): { promise: () => Promise<ArchiveElementPropertyRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveElementPropertyRuleEndpoint),
      endpoint: ArchiveElementPropertyRuleEndpoint
    };
  }

  export const ArchiveMultiElementPropertyRulesEndpoint = "/grpc/search_settings.ElementPropertyRules/ArchiveMultiElementPropertyRules";
  export function ArchiveMultiElementPropertyRules(sender: (req: ArchiveMultiElementPropertyRulesRequest, endpoint: string) => Promise<ArchiveMultiElementPropertyRulesResponse>, req: ArchiveMultiElementPropertyRulesRequest): { promise: () => Promise<ArchiveMultiElementPropertyRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMultiElementPropertyRulesEndpoint),
      endpoint: ArchiveMultiElementPropertyRulesEndpoint
    };
  }

  export const UnarchiveElementPropertyRuleEndpoint = "/grpc/search_settings.ElementPropertyRules/UnarchiveElementPropertyRule";
  /**
   * Unarchives an existing element property rule for an org.
   * Once unarchived, the element property rule can continue to be modified and will show up in GetAllElementPropertyRules.
   */
  export function UnarchiveElementPropertyRule(sender: (req: UnarchiveElementPropertyRuleRequest, endpoint: string) => Promise<UnarchiveElementPropertyRuleResponse>, req: UnarchiveElementPropertyRuleRequest): { promise: () => Promise<UnarchiveElementPropertyRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveElementPropertyRuleEndpoint),
      endpoint: UnarchiveElementPropertyRuleEndpoint
    };
  }

  export const UnarchiveMultiElementPropertyRulesEndpoint = "/grpc/search_settings.ElementPropertyRules/UnarchiveMultiElementPropertyRules";
  export function UnarchiveMultiElementPropertyRules(sender: (req: UnarchiveMultiElementPropertyRulesRequest, endpoint: string) => Promise<UnarchiveMultiElementPropertyRulesResponse>, req: UnarchiveMultiElementPropertyRulesRequest): { promise: () => Promise<UnarchiveMultiElementPropertyRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveMultiElementPropertyRulesEndpoint),
      endpoint: UnarchiveMultiElementPropertyRulesEndpoint
    };
  }

  export const GetAllElementPropertyRulesEndpoint = "/grpc/search_settings.ElementPropertyRules/GetAllElementPropertyRules";
  /**
   * Get all current non-archived element property rules for an org.
   * If desired, archived element property rules can also be retrieved with the explicit request flag.
   */
  export function GetAllElementPropertyRules(sender: (req: GetAllElementPropertyRulesRequest, endpoint: string) => Promise<GetAllElementPropertyRulesResponse>, req: GetAllElementPropertyRulesRequest): { promise: () => Promise<GetAllElementPropertyRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllElementPropertyRulesEndpoint),
      endpoint: GetAllElementPropertyRulesEndpoint
    };
  }

  export const GetElementPropertyRuleEndpoint = "/grpc/search_settings.ElementPropertyRules/GetElementPropertyRule";
  /** Get a specific element property rule, either current or past version. */
  export function GetElementPropertyRule(sender: (req: GetElementPropertyRuleRequest, endpoint: string) => Promise<GetElementPropertyRuleResponse>, req: GetElementPropertyRuleRequest): { promise: () => Promise<GetElementPropertyRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetElementPropertyRuleEndpoint),
      endpoint: GetElementPropertyRuleEndpoint
    };
  }

  export const BatchGetElementPropertyRulesEndpoint = "/grpc/search_settings.ElementPropertyRules/BatchGetElementPropertyRules";
  /** Get a specific set of element property rules, either current or past versions. */
  export function BatchGetElementPropertyRules(sender: (req: BatchGetElementPropertyRulesRequest, endpoint: string) => Promise<BatchGetElementPropertyRulesResponse>, req: BatchGetElementPropertyRulesRequest): { promise: () => Promise<BatchGetElementPropertyRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetElementPropertyRulesEndpoint),
      endpoint: BatchGetElementPropertyRulesEndpoint
    };
  }

  export const SetElementPropertyRuleEndpoint = "/grpc/search_settings.ElementPropertyRules/SetElementPropertyRule";
  /** Add a new element property rule or update an existing element property rule. */
  export function SetElementPropertyRule(sender: (req: SetElementPropertyRuleRequest, endpoint: string) => Promise<SetElementPropertyRuleResponse>, req: SetElementPropertyRuleRequest): { promise: () => Promise<SetElementPropertyRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetElementPropertyRuleEndpoint),
      endpoint: SetElementPropertyRuleEndpoint
    };
  }
}

export namespace ElementPropertyRulesPublic {

  export const ArchiveElementPropertyRuleEndpoint = "/grpc/search_settings.ElementPropertyRulesPublic/ArchiveElementPropertyRule";
  /**
   * Archive an existing element property rule for an org.
   * Once archived, the element property rule cannot be modified and will not show up in GetAllElementPropertyRules unless explicitly requested.
   */
  export function ArchiveElementPropertyRule(sender: (req: ArchiveElementPropertyRuleRequest, endpoint: string) => Promise<ArchiveElementPropertyRuleResponse>, req: ArchiveElementPropertyRuleRequest): { promise: () => Promise<ArchiveElementPropertyRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveElementPropertyRuleEndpoint),
      endpoint: ArchiveElementPropertyRuleEndpoint
    };
  }

  export const ArchiveMultiElementPropertyRulesEndpoint = "/grpc/search_settings.ElementPropertyRulesPublic/ArchiveMultiElementPropertyRules";
  export function ArchiveMultiElementPropertyRules(sender: (req: ArchiveMultiElementPropertyRulesRequest, endpoint: string) => Promise<ArchiveMultiElementPropertyRulesResponse>, req: ArchiveMultiElementPropertyRulesRequest): { promise: () => Promise<ArchiveMultiElementPropertyRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveMultiElementPropertyRulesEndpoint),
      endpoint: ArchiveMultiElementPropertyRulesEndpoint
    };
  }

  export const UnarchiveElementPropertyRuleEndpoint = "/grpc/search_settings.ElementPropertyRulesPublic/UnarchiveElementPropertyRule";
  /**
   * Unarchives an existing element property rule for an org.
   * Once unarchived, the element property rule can continue to be modified and will show up in GetAllElementPropertyRules.
   */
  export function UnarchiveElementPropertyRule(sender: (req: UnarchiveElementPropertyRuleRequest, endpoint: string) => Promise<UnarchiveElementPropertyRuleResponse>, req: UnarchiveElementPropertyRuleRequest): { promise: () => Promise<UnarchiveElementPropertyRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveElementPropertyRuleEndpoint),
      endpoint: UnarchiveElementPropertyRuleEndpoint
    };
  }

  export const UnarchiveMultiElementPropertyRulesEndpoint = "/grpc/search_settings.ElementPropertyRulesPublic/UnarchiveMultiElementPropertyRules";
  export function UnarchiveMultiElementPropertyRules(sender: (req: UnarchiveMultiElementPropertyRulesRequest, endpoint: string) => Promise<UnarchiveMultiElementPropertyRulesResponse>, req: UnarchiveMultiElementPropertyRulesRequest): { promise: () => Promise<UnarchiveMultiElementPropertyRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UnarchiveMultiElementPropertyRulesEndpoint),
      endpoint: UnarchiveMultiElementPropertyRulesEndpoint
    };
  }

  export const GetAllElementPropertyRulesEndpoint = "/grpc/search_settings.ElementPropertyRulesPublic/GetAllElementPropertyRules";
  /**
   * Get all current non-archived element property rules for an org.
   * If desired, archived element property rules can also be retrieved with the explicit request flag.
   */
  export function GetAllElementPropertyRules(sender: (req: GetAllElementPropertyRulesRequest, endpoint: string) => Promise<GetAllElementPropertyRulesResponse>, req: GetAllElementPropertyRulesRequest): { promise: () => Promise<GetAllElementPropertyRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllElementPropertyRulesEndpoint),
      endpoint: GetAllElementPropertyRulesEndpoint
    };
  }

  export const GetElementPropertyRuleEndpoint = "/grpc/search_settings.ElementPropertyRulesPublic/GetElementPropertyRule";
  /** Get a specific element property rule, either current or past version. */
  export function GetElementPropertyRule(sender: (req: GetElementPropertyRuleRequest, endpoint: string) => Promise<GetElementPropertyRuleResponse>, req: GetElementPropertyRuleRequest): { promise: () => Promise<GetElementPropertyRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetElementPropertyRuleEndpoint),
      endpoint: GetElementPropertyRuleEndpoint
    };
  }

  export const SetElementPropertyRuleEndpoint = "/grpc/search_settings.ElementPropertyRulesPublic/SetElementPropertyRule";
  /** Add a new element property rule or update an existing element property rule. */
  export function SetElementPropertyRule(sender: (req: SetElementPropertyRuleRequest, endpoint: string) => Promise<SetElementPropertyRuleResponse>, req: SetElementPropertyRuleRequest): { promise: () => Promise<SetElementPropertyRuleResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetElementPropertyRuleEndpoint),
      endpoint: SetElementPropertyRuleEndpoint
    };
  }
}

export interface ArchiveElementPropertyRuleRequest {
  orgId: string;
  elementPropertyRuleId: string;
}

export interface ArchiveElementPropertyRuleResponse {
  elementPropertyRule: ElementPropertyRuleRecord | null;
}

export interface ArchiveMultiElementPropertyRulesRequest {
  orgId: string;
  elementPropertyRuleIds: string[];
}

export interface ArchiveMultiElementPropertyRulesResponse {
  elementPropertyRules: ElementPropertyRuleRecord[];
}

export interface UnarchiveElementPropertyRuleRequest {
  orgId: string;
  elementPropertyRuleId: string;
}

export interface UnarchiveElementPropertyRuleResponse {
  elementPropertyRule: ElementPropertyRuleRecord | null;
}

export interface UnarchiveMultiElementPropertyRulesRequest {
  orgId: string;
  elementPropertyRuleIds: string[];
}

export interface UnarchiveMultiElementPropertyRulesResponse {
  elementPropertyRules: ElementPropertyRuleRecord[];
}

export interface GetAllElementPropertyRulesRequest {
  orgId: string;
  /** If true, archived element property rules will also be returned. */
  includeArchived: boolean;
}

export interface GetAllElementPropertyRulesResponse {
  /** The list of element property rules matching the request parameters. */
  elementPropertyRules: ElementPropertyRuleRecord[];
  /**
   * The limit of active element property rules.
   * If length of active (i.e. non archived) element property rules are at or over limit, new elements will not be allowed.
   */
  activeLimit: number;
}

export interface GetElementPropertyRuleRequest {
  /** required */
  orgId: string;
  /** required */
  elementPropertyRuleId: string;
  /** optional.  If not specified, the most recent [limit] versions will be returned. */
  version: protobuf.int64;
  /** optional, max number of records to record; defaults to safe value */
  limit: number;
}

export interface GetElementPropertyRuleResponse {
  versions: ElementPropertyRuleRecord[];
}

export interface BatchGetElementPropertyRulesRequest {
  /** required */
  orgId: string;
  /** required */
  identifiers: BatchGetElementPropertyRulesRequest.Identifier[];
  /** optional, max number of records to return for unspecified versions; defaults to a single record */
  limit: number;
}

export namespace BatchGetElementPropertyRulesRequest {
  export interface Identifier {
    /** required */
    elementPropertyRuleId: string;
    /** optional. If not specified, the most recent [limit] versions will be returned. */
    version: protobuf.int64;
  }
}

export interface BatchGetElementPropertyRulesResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found defined events will still be represented with an empty versions result set.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetElementPropertyRulesResponse.Result[];
}

export namespace BatchGetElementPropertyRulesResponse {
  export interface Result {
    identifier: BatchGetElementPropertyRulesRequest.Identifier | null;
    versions: ElementPropertyRuleRecord[];
  }
}

export interface SetElementPropertyRuleRequest {
  orgId: string;
  /**
   * Element property rule to be created or updated.
   * If the id field is not set, an id will be generated and a element property rule will be stored.
   * If an id field is set, an existing element property rule must be in place to perform the update.
   */
  elementPropertyRule: ElementPropertyRule | null;
}

export interface SetElementPropertyRuleResponse {
  elementPropertyRule: ElementPropertyRuleRecord | null;
}

export interface ElementPropertyRule {
  id: string;
  name: string;
  description: string;
  /**
   * any element is eligible
   * the choice of "any" element is only allowed for attribute selection
   * when "any" is used as the element matcher, child and ancestor settings do not apply as the attribute is extracted directly from/to this element
   */
  any?: boolean;
  /** id of the named element that when matched should have the corresponding property produced */
  namedElementId?: string;
  /** selectors (ORed union) of the element that when matched should have the corresponding property produced */
  selectors?: ElementPropertyRule.ElementSelectors | null;
  /**
   * any child element is eligible
   * the choice of "any" child element is only for attribute selection
   * when "any" is used as the child element matcher, we will take the nearest matched attribute for extraction
   */
  anyChild?: boolean;
  /** id of the named element that when matched should set the basis for source extraction */
  childNamedElementId?: string;
  /** selectors (ORed union) of the element that when matched should set the basis for source extraction */
  childSelectors?: ElementPropertyRule.ElementSelectors | null;
  /** source of property is an attribute at or above the level of the matching element */
  attribute?: ElementPropertyRule.SourceAttribute | null;
  /** source of property is the inner text value relative to the matching element */
  innerText?: ElementPropertyRule.SourceInnerText | null;
  /** source of property is a static value */
  static?: ElementPropertyRule.SourceStatic | null;
  /** value produced is the result of a regex match / capture groups on the raw source data */
  regex?: ElementPropertyRule.ValueProducerRegex | null;
  /** the type of the resulting property for which the source data should be parsed */
  propertyType: vars.Type;
  /** the name of the resulting property in the custom schema */
  propertyName: string;
}

export namespace ElementPropertyRule {
  /**
   * the element that needs to be matched to initiate the property extraction
   * the level at which the element is matched sets the basis for the source
   * any successfully extracted properties will be set at the level of the matched element
   */
  export enum element {
    /**
     * any element is eligible
     * the choice of "any" element is only allowed for attribute selection
     * when "any" is used as the element matcher, child and ancestor settings do not apply as the attribute is extracted directly from/to this element
     */
    any = 4,
    /** id of the named element that when matched should have the corresponding property produced */
    namedElementId = 5,
    /** selectors (ORed union) of the element that when matched should have the corresponding property produced */
    selectors = 6
  }

  /**
   * the element that needs to be matched to initiate the property extraction
   * the level at which the element is matched sets the basis for the source
   * any successfully extracted properties will be set at the level of the matched element
   */
  export function element_oneof(m: ElementPropertyRule): { opt: element.any, val: boolean } | { opt: element.namedElementId, val: string } | { opt: element.selectors, val: ElementPropertyRule.ElementSelectors } | null {
    if (m.any != null) { return { opt: element.any, val: m.any } }
    if (m.namedElementId != null) { return { opt: element.namedElementId, val: m.namedElementId } }
    if (m.selectors != null) { return { opt: element.selectors, val: m.selectors } }
    return null;
  }

  /**
   * if set, moves the basis for the source extraction to the matching child relative to the source element
   * the nearest child (least depth, first sibling) will be used in the case of multiple matches
   * child selection does not change how the resulting property will be applied -- it will still apply at level of the matching element
   */
  export enum child {
    /**
     * any child element is eligible
     * the choice of "any" child element is only for attribute selection
     * when "any" is used as the child element matcher, we will take the nearest matched attribute for extraction
     */
    anyChild = 7,
    /** id of the named element that when matched should set the basis for source extraction */
    childNamedElementId = 8,
    /** selectors (ORed union) of the element that when matched should set the basis for source extraction */
    childSelectors = 9
  }

  /**
   * if set, moves the basis for the source extraction to the matching child relative to the source element
   * the nearest child (least depth, first sibling) will be used in the case of multiple matches
   * child selection does not change how the resulting property will be applied -- it will still apply at level of the matching element
   */
  export function child_oneof(m: ElementPropertyRule): { opt: child.anyChild, val: boolean } | { opt: child.childNamedElementId, val: string } | { opt: child.childSelectors, val: ElementPropertyRule.ElementSelectors } | null {
    if (m.anyChild != null) { return { opt: child.anyChild, val: m.anyChild } }
    if (m.childNamedElementId != null) { return { opt: child.childNamedElementId, val: m.childNamedElementId } }
    if (m.childSelectors != null) { return { opt: child.childSelectors, val: m.childSelectors } }
    return null;
  }

  /**
   * source specifies which piece of raw data should be used for extraction
   * source data is always extracted relative to the matched element basis
   * by default, the basis is the configured target element
   * if a child is set, the basis moves to the configured child element
   */
  export enum source {
    /** source of property is an attribute at or above the level of the matching element */
    attribute = 10,
    /** source of property is the inner text value relative to the matching element */
    innerText = 11,
    /** source of property is a static value */
    static = 12
  }

  /**
   * source specifies which piece of raw data should be used for extraction
   * source data is always extracted relative to the matched element basis
   * by default, the basis is the configured target element
   * if a child is set, the basis moves to the configured child element
   */
  export function source_oneof(m: ElementPropertyRule): { opt: source.attribute, val: ElementPropertyRule.SourceAttribute } | { opt: source.innerText, val: ElementPropertyRule.SourceInnerText } | { opt: source.static, val: ElementPropertyRule.SourceStatic } | null {
    if (m.attribute != null) { return { opt: source.attribute, val: m.attribute } }
    if (m.innerText != null) { return { opt: source.innerText, val: m.innerText } }
    if (m.static != null) { return { opt: source.static, val: m.static } }
    return null;
  }

  /**
   * given raw source data, the value producer can take the raw data and produce a property value using it
   * if omitted, the value produced is the same as the raw source data
   */
  export enum value_producer {
    /** value produced is the result of a regex match / capture groups on the raw source data */
    regex = 15
  }

  /**
   * given raw source data, the value producer can take the raw data and produce a property value using it
   * if omitted, the value produced is the same as the raw source data
   */
  export function value_producer_oneof(m: ElementPropertyRule): { opt: value_producer.regex, val: ElementPropertyRule.ValueProducerRegex } | null {
    if (m.regex != null) { return { opt: value_producer.regex, val: m.regex } }
    return null;
  }

  export interface ElementSelectors {
    selectors: segment.PlatformSelector[];
  }

  export interface SourceAttribute {
    /** the name of the attribute whose value will be extracted for parsing */
    attribute: string;
    /**
     * if true, includes ancestors when looking for the corresponding attribute
     * the attribute on the ancestor nearest to the target element / child element
     */
    includeAncestors: boolean;
  }

  /** intentionally empty, leaving for future config options */
  export interface SourceInnerText {
  }

  export interface SourceStatic {
    /** the static value that acts as the source data for the property */
    value: string;
  }

  export interface ValueProducerRegex {
    /**
     * regex expression for which the value should be extracted
     * by default, the first matched result will be used
     * if capture groups are supplied, the first captured value will be used
     * if a format is supplied, the capture groups can be referenced by index using (1), (2), etc.
     */
    expression: string;
    /**
     * optional
     * the format of the produced value based on the regex expression
     * can reference the capture groups by index using (1), (2), etc.
     * defaults can be supplied for capture group values that produce an empty value using the format (1?default)
     */
    format: string;
  }
}

export interface ElementPropertyRuleRecord {
  elementPropertyRule: ElementPropertyRule | null;
  metadata: protoauditstore.AuditMetadata | null;
}
